<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-default">
    </base-header>
    <b-container fluid class="mt--7">
     <div class="row">
       <div class="col-lg-4 col-md-12 col-sm-12">
         <Personal :user="user"/>
       </div>
       <div class="col-lg-8 col-md-12 col-sm-12">
         <Dashboard :user="user" @reloadData="getData"/>
       </div>
     </div>
      <b-row class="mt-5" v-if="user.type === 'client'">
        <b-col>
          <b-tabs fill >
            <b-tab active title="Notificaciones del sistema">
              <Notifications/>
            </b-tab>
            <b-tab active title="Notificaciones asignadas al usuario">
              <NotificationsUser/>
            </b-tab>
            <b-tab title="Transacciones">
              <Transactions/>
            </b-tab>
            <b-tab title="Cuentas">
              <Accounts/>
            </b-tab>
            <b-tab title="Archivos">
              <Files/>
            </b-tab>
            <b-tab title="Documentos">
              <documents/>
            </b-tab>
            <b-tab title="Enviar dinero">
              <SendMoney/>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </b-container>
  </div>

</template>

<script>
import Personal from './Detail_Personal'
import Dashboard from './Detail_Dashboard'
import Accounts from './Accounts'
import {get} from "@/util/axiosRequest";
import Files from "@/views/Dashboard/users/Files";

export default {
  name: "Detail",
  components: {
    Files,
    Personal,
    Dashboard,
    Accounts
  },
  data: () => ({
    user: {
      _id: null,
      name: null,
      email: null,
      identification: null,
      phone: null,
      isActive: null,
      created_at: null,
      account_number: null,
      agent_id: null,
      photo: null
    },
  }),
  mounted() {
    this.user._id = this.$route.params.id
    this.getData()
  },
  methods: {
    getData() {
      get("users/find-one", this.user._id, true).then(({data}) => {
        data.password = null
        this.user = data
      })
    }
  }
}
</script>

<style scoped>
.nav{
  justify-content: center !important;
}
</style>
